module.exports = __webpack_public_path__ + "static/help-to-streamline-your-business-967eabc6b125fbd2e1a5940fe9794548.png";